/**
 * Internationalization (i18n) Default Configuration
 */
const defaultTranslations = {

    // Project
    prepInfo    : 'Info Allgemein/Vorbereitung',
    prep1       : 'Höhenaufnahmen',
    prep2       : 'Meterrisse/Höhen erstellt',
    prep3       : 'Fugenplan',
    prep4       : 'Fugen angezeichnet',
    prep5       : 'Installation bereit',
    prep6       : 'Bestellungen erledigt',
    prep7       : 'Reserve 7',
    prep8       : 'Reserve 8',
    prep9       : 'Reserve 9',
};

// --------------------------------------------------------------------------------------------------------------------
// i18n logic & state
// --------------------------------------------------------------------------------------------------------------------

export let i18n = { ...defaultTranslations };

/**
 * Überschreibt/erweitert das Wörterbuch mit neuen Texten (z. B. geladene Sprache aus API/JSON)
 *
 * Overload and/or enhance i18n words with new texts (from database or json for example).
 */
export const loadLanguage = (dictionary) => {
    if (dictionary && typeof dictionary === 'object') {
        i18n = {
            ...i18n,
            ...dictionary
        };
    }
};

/**
 * Reset to default language.
 */
export const resetLanguage = () => {
    i18n = { ...defaultTranslations };
};


// --------------------------------------------------------------------------------------------------------------------
// The end.